import moment from 'moment';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { notification } from 'tea-component';
import { isLegalHttpUrl } from '@gp/utils/common';
import { ENTERPRISE_WECHAT_LINK } from '@gp/constants/const';
import { forEach } from 'lodash';

export const FILTER_STORAGE_VALUE_KEY = '__dbg_filter_storage_value__';
export const FILTER_SAVE_VALUE_KEY = '__dbg_filter_save_value__';
export const FILTER_SAVE_SELECTED_VALUE = '__dbg_filter_save_selected_value__';

/** *
 * 对象树种查找某个值
 * @param (object,key, [key])
 */
export function find() {
  const arr = Array.prototype.slice.call(arguments);
  return arr.reduce((obj, key) => {
    return typeof obj === 'object' ? obj[key] : undefined;
  });
}

/** *
 * 清除字符串两端空格
 * @param
 */
export function trim(str) {
  return str ? str.replace(/(^\s*)|(\s*$)/g, '') : str;
}

/** *
 * 设置cookie
 * @param
 */
export function setCookie(name, value, expiredays, path, domain) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = `${name}=${escape(value)}${!path ? '' : `;path=${path}`}${
    !domain ? '' : `;domain=${domain}`
  }${!expiredays ? '' : `;expires=${exdate.toGMTString()}`}`;
}

/** *
 * 获取cookie
 * @param
 */
export function getCookie(key) {
  let temp;
  const arr = document.cookie.split(';').map((item) => {
    temp = item.split('=');
    return { key: trim(temp[0]), value: trim(temp[1]) };
  });
  temp = arr.find((item) => item.key === key);
  return unescape((temp && temp.value) || '');
}

/** *
 * 清除cookie
 * @param whiteCookie 白名单cookie，白名单中的cookie，不清除
 */
export function clearCookie(whiteCookie = []) {
  const cookies = document.cookie.split(';');
  for (let i = 0;i < cookies.length;i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? trim(cookie.substr(0, eqPos)) : cookie;
    if (whiteCookie.indexOf(name) > -1) {
      continue;
    }
    document.cookie = `${name}=;domain=${location.hostname};expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
}

/** *
 * 设置stroage
 * @param
 */
export const storage = {
  getType(type) {
    return type === 'localStorage' ? 'localStorage' : 'sessionStorage';
  },
  getItem(key, type = 'localStorage') {
    const objstr = window[this.getType(type)].getItem(key);
    if (!objstr) return null;
    try {
      const json = JSON.parse(objstr) || {};
      const { _value, _expire } = json;
      if (_expire) {
        if (Date.now() > _expire) {
          // 过期，删掉记录
          this.removeItem(key, type);
          return null;
        }
        return _value;
      }
      if (Object.prototype.hasOwnProperty.call(json, '_value')) {
        return _value;
      }
      return json;
    } catch (e) {
      return objstr;
    }
  },

  setItem(key, val, type = 'localStorage', expire) {
    // 可以存空字符串、0、false
    if (val === undefined || val === null) {
      // 清除记录
      this.removeItem(key, type);
      return;
    }
    const obj = {
      _value: val,
    };
    if (expire) {
      obj._expire = expire;
    }
    window[this.getType(type)].setItem(key, JSON.stringify(obj));
  },

  removeItem(key, type = 'localStorage') {
    window[this.getType(type)].removeItem(key);
  },

  getLocalStorageItem(key) {
    return this.getItem(key, 'localStorage');
  },

  setLocalStorageItem(key, val, expire) {
    this.setItem(key, val, 'localStorage', expire);
  },

  removeLocalStorageItem(key) {
    this.removeItem(key, 'localStorage');
  },

  getSessionStorageItem(key, removeAfterRead = false) {
    const value = this.getItem(key, 'sessionStorage');
    if (removeAfterRead) {
      this.removeSessionStorageItem(key);
    }
    return value;
  },

  setSessionStorageItem(key, val, expire) {
    this.setItem(key, val, 'sessionStorage', expire);
  },

  removeSessionStorageItem(key) {
    this.removeItem(key, 'sessionStorage');
  },
};

/** *
 * 嵌入式设置登录
 * @param
 */
export function setEmbedToken(token) {
  window.sessionStorage.setItem('gp-embed-token', token);
}

/** *
 * 嵌入式获取登录
 * @param
 */
export function getEmbedToken() {
  return window.sessionStorage.getItem('gp-embed-token');
}

/** *
 * 普通登陆设置登录
 * @param
 */
export function setLogin(authorization) {
  window.sessionStorage.setItem('authorization', authorization);
  setCookie('db-authorization', authorization, '', '/');
}

/** *
 * 获取登录token
 * @param
 */

export function getAuthorization() {
  return window.sessionStorage.getItem('authorization') || getCookie('db-authorization');
}

export const doLogout = () => {
  window.sessionStorage.removeItem('authorization');
  clearCookie();
  const redirect = encodeURIComponent(window.location.href);
  // 已经是登录页面就不跳转
  if (window.location.href?.indexOf('/login?redirect=') === -1) {
    window.location.href = `/login?redirect=${redirect}&type=out`;
  }
};

// 计算生成刻度线数据
export const getDateStepByRange = ([start, end], step, format, minLen = 0) => {
  if (Array.isArray(start)) {
    start = moment().add(start[0], start[1]);
  } else {
    start = moment(start);
  }
  if (Array.isArray(end)) {
    end = moment().add(end[0], end[1]);
  } else {
    end = moment(end);
  }
  const stepUnit = Array.isArray(step) ? step[1] : step;
  const stepValue = Array.isArray(step) ? step[0] : 1;
  const collection = [];
  const current = start.clone();
  while (!current.isAfter(end, stepUnit) || collection.length < minLen) {
    const currentDate = typeof format === 'string' ? current.format(format) : current.clone();
    collection.push(currentDate);
    current.add(stepValue, stepUnit);
  }
  return collection;
};

// 返回一个字符串的字节长度，一个中文占两个字节
export const getStrlen = (str) => {
  let len = 0;
  const re = /[\u4e00-\u9fa5]/;
  for (let i = 0, l = str.length;i < l;i++) {
    if (re.test(str.charAt(i))) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
};

/**
 * 获取固定宽度的字符串，如果传入的text的宽度不够width，则返回原字符串
 * @text 将要被提取的原字符串
 * @lineWidth 单行宽度，用于存在\n换行计算
 * @width 想要提取的字符串宽度
 * @fontSize 字号大小
 * @isNeedEllipsis 当text的宽度大于width时是否需要省略号
 * @fontStyleCSSText 文案样式
 * @fontClassName 文案类名
 * @containerEl 文案容器dom
 */
export const getFixedWidthText = (
  text,
  lineWidth,
  width,
  fontSize = 12,
  fontWight = 400,
  isNeedEllipsis = true,
  fontStyleCSSText = '',
  fontClassName = '',
  containerEl = null,
) => {
  let returnText = '';
  let oldText = '';
  let newText = '';
  let lastWidth = 0;
  let lineFeedWidth = 0; // 换行导致多出来的宽度
  let endStrLineFeeWidth = 0; // 如果oldText尾部是换行符，记录换行符占的宽度
  let lineFeeAccessed = false; // 记录换行符导致计算零界点是否有触碰到
  if (!text || width < fontSize || typeof text !== 'string') return returnText;
  const arr = text.split('');
  const span = document.createElement('span');
  // span.style.visibility = 'hidden';
  // span.style.padding = '0';
  // span.style['white-space'] = 'nowrap';
  // span.style['overflow-x'] = 'auto';
  // span.style.fontSize = fontSize > 12 ? fontSize + 'px' : '12px';
  // span.style.fontWeight = fontWight;
  const fixedCSSText = `position:absolute;visibility:hidden;padding:0;white-space:nowrap;overflow-x:auto;font-size:${
    fontSize > 12 ? `${fontSize}px` : '12px'
  };font-weight:${fontWight};`;
  span.style.cssText = fixedCSSText + fontStyleCSSText;
  span.setAttribute('class', fontClassName);
  containerEl ? containerEl?.appendChild(span) : document.body.appendChild(span);

  for (let i = 0, l = arr.length;i < l;i++) {
    const item = arr[i];
    oldText = newText;
    let currentLineFeeWidth = 0;
    const itemIsLineFee = item === '\n';
    const lastItemIsLineFee = arr[i - 1] === '\n';
    if (itemIsLineFee) {
      if (lastItemIsLineFee) {
        currentLineFeeWidth = lineWidth;
        lineFeedWidth += currentLineFeeWidth;
      } else {
        currentLineFeeWidth = lineWidth - (lastWidth % lineWidth);
        lineFeedWidth += currentLineFeeWidth;
      }
    }
    newText += item;
    span.innerHTML = newText;
    const nowWidth = span.offsetWidth + lineFeedWidth;
    if (itemIsLineFee && nowWidth === width) {
      lineFeeAccessed = true;
    }
    if (nowWidth > width) {
      // 避免末尾换行符时，计算出来的宽度没有减去按钮占用的宽度提前一步程序跑进来，这时忽略这一次
      if (itemIsLineFee && !lineFeeAccessed) {
        lineFeeAccessed = true;
        endStrLineFeeWidth = currentLineFeeWidth - (nowWidth - width);
        lastWidth = width;
        returnText = newText;
        continue;
      }
      if (isNeedEllipsis) {
        span.innerHTML = '...';
        const ellipsisWidth = span.offsetWidth; // 追加省略号占的宽度
        let finalStr = '...';
        // 尾部换行符占的宽度大于等于...省略号占的宽度时把换行符改成...省略号
        if (endStrLineFeeWidth >= ellipsisWidth) {
          finalStr = `${oldText?.slice(0, -1)}...`;
        } else {
          const strArr = oldText?.split('');
          // 计算尾部多少个字符等价...省略号占的宽度，并替换成...省略号
          for (let j = 0;j < strArr?.length;j++) {
            const lastStr = oldText?.slice(-(j + 1));
            span.innerHTML = lastStr;
            if (span.offsetWidth + endStrLineFeeWidth >= ellipsisWidth) {
              finalStr = `${oldText?.slice(0, -(j + 1))}...`;
              break;
            }
          }
        }
        returnText = finalStr;
      } else {
        returnText = oldText;
      }
      break;
    } else {
      if (itemIsLineFee) {
        endStrLineFeeWidth = currentLineFeeWidth;
      } else {
        endStrLineFeeWidth = 0;
      }
    }
    lastWidth = nowWidth;
    returnText = newText;
  }

  containerEl ? containerEl?.removeChild(span) : document.body.removeChild(span);
  return returnText;
};

export const formatDurationTime = (duration) => {
  const num = parseInt(duration);
  if (isNaN(num)) return '';
  let hours = Math.floor(num / (60 * 60));
  let minutes = Math.floor((num % (60 * 60)) / 60);
  let seconds = Math.floor(num % 60);

  hours = `${hours}`.padStart(2, '0');
  minutes = `${minutes}`.padStart(2, '0');
  seconds = `${seconds}`.padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

export const downloadImage = (url) => {
  const iframe = document.createElement('iframe');
  const linker = document.createElement('a');
  iframe.style.display = 'none';
  linker.setAttribute('href', url);
  linker.setAttribute('download', '页面截屏');
  document.body.appendChild(iframe);
  linker.click();
  document.body.removeChild(iframe);
};

export const downloadPDF = (fileName, url, width, height) => {
  const pdf = new jsPDF(width >= height ? 'l' : 'p', 'px', [width, height]);
  pdf.addImage(url, 'JPEG', 0, 0, width, height);
  pdf.save(`${fileName}.pdf`);
};

const captureRemoveClassName = 'text-overflow-processor-on';
const captureExpendClassName = 'text-overflow-processor-off';

export const captureNode = async (fileName, node, nodeOptions, options) => {
  const { onclone, ...remainOptions } = options || {};
  const nodeContainerStyle = nodeOptions?.ownerStyle;
  const width = parseFloat(getComputedStyle(node).getPropertyValue('width'));
  const height = parseFloat(getComputedStyle(node).getPropertyValue('height'));
  const canvas = await html2canvas(node || document.body, {
    useCORS: true,
    scale: 1,
    backgroundColor: '#f2f3f5',
    // width,
    // height,
    // windowWidth: width,
    // windowHeight: height,
    onclone(document, element) {
      if (!element) return;
      if (nodeContainerStyle) {
        element.style.cssText = nodeContainerStyle;
      }
      if (nodeOptions?.othersOptions) {
        Object.keys(nodeOptions.othersOptions).forEach((item) => {
          const el = element.querySelectorAll(`.${item}`);
          el?.forEach((t) => {
            t.style.cssText = nodeOptions.othersOptions?.[item];
          });
        });
      }
      const hideEls = element.querySelectorAll(`.${captureRemoveClassName}`);
      const showEls = element.querySelectorAll(`.${captureExpendClassName}`);
      document.body.style.height = 'auto';
      document.querySelector('#root').style.height = 'auto';
      hideEls.forEach((el) => {
        el.style.display = 'none';
      });
      showEls.forEach((el) => {
        el.style.display = 'inline-block';
        el.style['-webkit-box-orient'] = 'unset';
      });
      onclone instanceof Function && onclone();
    },
    ...remainOptions,
  });
  const dataURL = canvas.toDataURL('png', 1);
  // downloadImage(dataURL);
  downloadPDF(
    fileName || '页面截屏',
    dataURL,
    nodeOptions?.width || width,
    nodeOptions?.height || height,
  );
};

/**
 *
 * @param {string} link 企业微信链接
 * @returns 获取有效企业微信链接
 */
export const getValidEnterpriseWeChatLink = (link) => {
  return isLegalHttpUrl(link) ? link : ENTERPRISE_WECHAT_LINK;
};

export const isNullOrUndefined = (data) => data === undefined || data === null;

export const isEmpty = (data) => {
  return (
    isNullOrUndefined(data) ||
    (typeof data === 'string' && data.trim().length === 0) ||
    (typeof data === 'number' && isNaN(data))
  );
};

export const getTextWithPlaceholder = (data, placeholder = '-') =>
  !isEmpty(data) ? data : placeholder;

// 复制内容0：内容不存在 1：复制成功 2：复制失败
export function copyContent(v = '') {
  let copyRes = 0;
  if (!v) return copyRes;
  const inputEl = document.createElement('textarea');
  inputEl.value = v;
  inputEl.style.position = 'fixed';
  inputEl.style.top = '-9999px';
  inputEl.style.left = '-9999px';
  document.body.appendChild(inputEl);
  inputEl.setSelectionRange(0, 9999); // 兼容ios
  inputEl.select();
  try {
    document.execCommand('copy');
    copyRes = 1;
  } catch (error) {
    copyRes = 2;
  }
  document.body.removeChild(inputEl);
  return copyRes;
}

export const copyContentWithNotification = (name) => {
  const copyRes = copyContent(name || '');
  if (copyRes === 1) {
    // 复制成功
    notification.success({
      description: 'Successful replication',
      duration: 1000,
    });
  } else {
    // 复制失败
    notification.error({
      description: 'Replication failure',
      duration: 1000,
    });
  }
};

// 获取继承缓存值
export const getFilterStorageValue = () => {
  const filterStorageValue = storage.getItem(FILTER_STORAGE_VALUE_KEY, 'sessionStorage');
  if (!filterStorageValue) {
    return {};
  }
  return filterStorageValue;
};

// 获取保存方案缓存值
export const getFilterSaveValue = () => {
  const filterStorageValue = storage.getItem(FILTER_SAVE_VALUE_KEY, 'sessionStorage');
  if (!filterStorageValue) {
    return {};
  }
  return filterStorageValue;
};

// 获取保存方案对象
export const getFilterSaveSelectedValue = () => {
  const filterSelectedValue = storage.getItem(FILTER_SAVE_SELECTED_VALUE, 'sessionStorage');
  if (!filterSelectedValue) {
    return {};
  }
  return filterSelectedValue;
};

// 设置继承缓存值
export const setFilterStorageValue = (value = {}) => {
  const { value: oldValue = {} } = getFilterStorageValue();
  // const valueKeys = Object.keys(value) || [];
  // const timeType = valueKeys?.includes('rangeMonthly') ? 'Month' : valueKeys?.includes('rangeWeekly') ? 'Week' : 'Day';
  storage.setItem(
    FILTER_STORAGE_VALUE_KEY,
    {
      ...oldValue,
      ...value,
    },
    'sessionStorage',
  );
};

// 设置保存方案缓存值
export const setFilterSaveValue = (value = {}) => {
  storage.setItem(
    FILTER_SAVE_VALUE_KEY,
    {
      ...value,
    },
    'sessionStorage',
  );
};

// 设置保存方案对象缓存值
export const setFilterSaveSelectedValue = (value = {}) => {
  storage.setItem(
    FILTER_SAVE_SELECTED_VALUE,
    {
      ...value,
    },
    'sessionStorage',
  );
};

// 删除继承缓存值
export const deleteFilterStorageValue = () => {
  // 清除继承、保存方案
  storage.removeSessionStorageItem(FILTER_STORAGE_VALUE_KEY);
};

// 删除保存方案缓存值
export const deleteFilterSaveValue = () => {
  // 清除保存方案
  storage.removeSessionStorageItem(FILTER_SAVE_VALUE_KEY);
};
// 删除保存方案对象缓存值
export const deleteFilterSaveSelectedValue = () => {
  // 清除保存方案
  storage.removeSessionStorageItem(FILTER_SAVE_SELECTED_VALUE);
};

// 删除保存继承所有缓存值
export const deleteFilterAllValue = () => {
  deleteFilterStorageValue();
  deleteFilterSaveValue();
  deleteFilterSaveSelectedValue();
};

export const formatStorageValue = (fields, value) => {
  const cacheValue = {};
  fields.forEach((item) => {
    // 获取筛选器类型，优先取type，没type取key值
    const key = item.key || item.type;
    cacheValue[key] = value[item.key];
  });
  return cacheValue;
};
